module.exports = __webpack_public_path__ + "img/single_sample.3651c345.svg";